import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Workspace.css';
import Button from '../Components/Common/Button';
import api from '../api/axios'; 
import { useTheme } from '../ThemeContext';
import { toast } from "react-toastify";

const Workspace = () => {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const [workspaceName, setWorkspaceName] = useState('');
  const [loading, setLoading] = useState(true); // Start as loading to check DB first

  // --- UPDATED ROUTE GUARD: Check Database on page load ---
  useEffect(() => {
    const checkExistingWorkspace = async () => {
      try {
        // 1. Call the check route we added to index.js
        const response = await api.get('/workspaces/check');
        
        if (response.data.hasWorkspace) {
          // 2. If it exists in DB, update localStorage and skip this page
          const user = JSON.parse(localStorage.getItem('user')) || {};
          user.hasWorkspace = true;
          localStorage.setItem('user', JSON.stringify(user));
          
          navigate('/home', { replace: true }); 
        } else {
          // 3. If no workspace found, stay on this page and stop loading spinner
          setLoading(false);
        }
      } catch (err) {
        console.error("Workspace check failed:", err);
        setLoading(false);
      }
    };

    checkExistingWorkspace();
  }, [navigate]);

  const handleIndividualSubmit = async (e) => {
    e.preventDefault();
    if (!workspaceName) return;

    setLoading(true);
    try {
      await api.post('/workspaces', {
        workspace_name: workspaceName,
        workspace_type: 'individual',
        industry: null,
        department: null
      });

      const user = JSON.parse(localStorage.getItem('user')) || {};
      user.hasWorkspace = true;
      localStorage.setItem('user', JSON.stringify(user));

      navigate('/home', { replace: true }); 
    } catch (err) {

  const errorMessage =
    err.response?.data?.message ||
    "Failed to create workspace.";

  toast.error(errorMessage);

} finally {
  setLoading(false);
}
};

  // While checking the database, show a simple loading message
  if (loading && !workspaceName) {
    return <div className="workspace-wrapper">Checking for existing workspace...</div>;
  }

  return (
    <div className="workspace-wrapper">
      <div className="workspace-card text-center" style={{ 
  backgroundColor: '#F5F5F5',   // ← fix
  color: 'var(--text-main)',
  borderColor: 'var(--border-color)'
}}>
        <div className="logo-section">
          <img src="/images/kinenew.svg" alt="KINEXAR" className="title-img" style={{ filter: theme === 'dark' ? 'brightness(0) invert(1)' : 'none' }} />
        </div>
<h2 className="workspace-header"><strong>Set up Your Workspace</strong></h2>
       <div className="form-container mx-auto">
  <div className="workspace-team-block">
    <label className="workspace-label">Workspace Team*</label>
    <div className="d-flex gap-3">
      <div className="selection-box d-flex align-items-center p-3 active">
        <img src="/images/indinew.svg" alt="Individual" className="option-icon me-2" />
        <div className="text-start flex-grow-1">
          <div className="option-title">Individual</div>
          <div className="option-subtitle">Personal Account</div>
        </div>
        <div className="custom-radio"><div className="radio-inner selected"></div></div>
      </div>

      <div
        className="selection-box d-flex align-items-center p-3"
        onClick={() => navigate('/workspace-company')}
        style={{ cursor: 'pointer' }}
      >
        <img src="/images/conew.svg" alt="Company" className="option-icon me-2" />
        <div className="text-start flex-grow-1">
          <div className="option-title">Company</div>
          <div className="option-subtitle">Team Account</div>
        </div>
        <div className="custom-radio"><div className="radio-inner"></div></div>
      </div>
    </div>
  </div>

  <form onSubmit={handleIndividualSubmit}>
    <div className="workspace-name-block">
      <label className="workspace-label">Workspace Name*</label>
      <input
        type="text"
        className="form-control custom-input"
        placeholder="Enter Workspace Name"
        value={workspaceName}
        onChange={(e) => setWorkspaceName(e.target.value)}
        required
        disabled={loading}
      />
    </div>

    <Button type="submit" disabled={loading}>
      {loading ? "Creating..." : "Create Workspace"}
    </Button>
  </form>
</div>
      </div>
    </div>
  );
};

export default Workspace;